import { firestoreOperationsDb } from '../firebase/firebase';
import firebase from 'firebase';

/**
 * Persists which quick tip contexts (screens/modals) a user has already seen.
 *
 * Collection: quickTipsSeen
 * Doc: {userId}
 * Fields:
 *  - contexts: string[]   (contextIds the user has seen)
 *  - updatedAt: timestamp
 */
class QuickTipsSeenService {
  constructor() {
    this.db = firestoreOperationsDb;
    this.collectionPath = 'quickTipsSeen';
  }

  async getSeenContexts(userId) {
    try {
      if (!userId) return [];
      const doc = await this.db.collection(this.collectionPath).doc(userId).get();
      if (!doc.exists) return [];
      const data = doc.data() || {};
      return Array.isArray(data.contexts) ? data.contexts : [];
    } catch (error) {
      console.error('Error fetching quick tips seen contexts:', error);
      return [];
    }
  }

  async markContextSeen(userId, contextId) {
    try {
      if (!userId || !contextId) return;
      await this.db
        .collection(this.collectionPath)
        .doc(userId)
        .set(
          {
            contexts: firebase.firestore.FieldValue.arrayUnion(contextId),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
    } catch (error) {
      console.error('Error marking quick tip context seen:', error);
      // swallow; localStorage is still the source of truth for this session
    }
  }
}

const quickTipsSeenService = new QuickTipsSeenService();
export default quickTipsSeenService;


